import { combineReducers } from 'redux';

import type { EditorContentV2Type } from './editorContentV2.ts';
import editorContentV2 from './editorContentV2.ts';
import { mediaPreviewer } from './mediaPreviewer.js';
import type { DraftStateType } from './draft.ts';
import { default as draft } from './draft.ts';

export type ViewState = {
	editorContentV2: EditorContentV2Type;
	mediaPreviewer: any;
	draft: DraftStateType;
};

export default combineReducers({
	editorContentV2,
	mediaPreviewer,
	draft,
});
